import * as React from "react";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import StreamsContext from "contexts/StreamsContext";
import FilterPreviewResults from "components/event-definitions/event-definition-types/FilterPreviewResults";
import FilterPreview from "./FilterPreview";
const FilterPreviewContainer = ({ eventDefinition }) => {
  const { t } = useTranslation("event_definitions");
  const streams = useContext(StreamsContext);
  return (streams == null ? void 0 : streams.length) ? /* @__PURE__ */ React.createElement(FilterPreview, { config: eventDefinition == null ? void 0 : eventDefinition.config }) : /* @__PURE__ */ React.createElement(FilterPreviewResults, null, t("filter_preview.no_streams_access"));
};
export default FilterPreviewContainer;
